module.exports = __webpack_public_path__ + "img/Instagram-Badge.64181d43.png";